import BtsView from '@/pages/bts/BtsView';
import BtsUpload from '@/pages/bts/BtsUpload';
import BtsProposal from '@/pages/bts/BtsProposal';
import UploadBtsProposal from '@/pages/bts/UploadBtsProposal';
import ProposalProduct from '@/pages/bts/ProposalProduct';
import ReviewChanges from '@/pages/bts/ReviewChanges';
import UploadBtsManual from '@/pages/bts/UploadBtsManual';
import OngoingChats from '@/pages/bts/OngoingChats';

const btsRoutes = [
  { path: 'bts', element: BtsView },
  { path: 'bts/upload', element: BtsUpload },
  { path: 'bts/create-proposal', element: BtsProposal },
  { path: 'bts/upload-bts-proposal', element: UploadBtsProposal },
  { path: 'bts/proposal-product/:id', element: ProposalProduct },
  { path: 'bts/review-changes/:id', element: ReviewChanges },
  { path: 'upload-manual', element: UploadBtsManual },
  { path: 'ongoing-chats', element: OngoingChats },
];

export default btsRoutes;
